import React, { useEffect } from 'react';
import styles from './AdViseStep5.module.css';

const AdViseStep5 = ({setAdViseStep, stepProps, setStepProps, marginTop}) => {
    /*useEffect(() => {
        setStepProps(prev => prev.map((item, index) => index >= 5 ? null : item));
    }, []);*/

    const whenHomeButtonClicked = () => {
        const back = window.confirm("선택한 정보들이 모두 초기화돼요.\n\n정말 첫 화면으로 돌아갈까요?");
        if(back)
            setAdViseStep(0)
    };

    const whenTypeSelected = (type) => {
        setStepProps(prev => {
            const newProps = [...prev];
            newProps[5] = type;
            return newProps;
        });
    };

    return (
        <div className={styles.outerframe}>
            <div className={styles.upperframe}>
                <img className={styles.backbuttonIcon} alt="" src="images/back_android.svg" onClick={()=>setAdViseStep(4)}/>
                <div className={styles.titleframe}>
                    <b className={styles.nextbuttontext}>STEP 5</b>
                    <div className={styles.stepdesc}>어떤 형식의 콘텐츠를 만들까요?</div>
                </div>
                <img className={styles.homebuttonIcon} alt="" src="images/home_outlined.svg" onClick={()=>whenHomeButtonClicked()}/>
            </div>
            <div className={styles.lowerframe} style={{height:`calc(100dvh - ${marginTop}px)`}}>
                <div className={styles.contentframe}>
                    <div className={stepProps[5]=='image' ? styles.activebuttonframe : styles.disabledbuttonframe} onClick={()=>whenTypeSelected('image')}>
                            <img className={stepProps[5]=='image' ? styles.mdiimagesIcon : styles.mdiimagesIconDisabled} alt="" src="images/image.svg" />
                            <div className={styles.buttontextframe}>
                                <b className={styles.activebuttontitle}>이미지 형식</b>
                                <div className={styles.acitvebuttonsub}>
                                        <p className={styles.p}>인스타 피드에 최적화된</p>
                                        <p className={styles.p}>10장 분량의 카드 뉴스</p>
                                </div>
                            </div>
                    </div>
                    <div className={stepProps[5]=='video' ? styles.activebuttonframe2 : styles.disabledbuttonframe} onClick={()=>whenTypeSelected('video')}>
                            <img className={stepProps[5]=='video' ? styles.mdiimagesIcon2 : styles.mdiimagesIconDisabled} alt="" src="images/video.svg" />
                            <div className={styles.buttontextframe}>
                                <b className={styles.activebuttontitle}>영상 형식</b>
                                <div className={styles.acitvebuttonsub}>
                                        <p className={styles.p}>릴스/쇼츠에 최적화된</p>
                                        <p className={styles.p}>15초 분량의 숏폼</p>
                                </div>
                            </div>
                    </div>
                </div>
            </div>
            <div className={styles.nextbuttonframe}>
                <div className={styles.nextbutton} onClick={()=>setAdViseStep(6)}>
                    <b className={styles.nextbuttontext}>다음 →</b>
                </div>
            </div>
        </div>
    );
}

export default AdViseStep5;